import React, { useEffect, useState } from "react";
import { Box, Grid } from "@mui/material";
import { useDispatch, useSelector } from "react-redux";
import AdminLayout from "../../../layout/AdminLayout";
import { theme } from "../../../theme/theme";
import { CustomBtn } from "../../../components/Common/CustomBtn";
import AddPhotoModal from "../../../components/Modals/AddPhotoModal";
import MediaViewerModal from "../../../components/Common/MediaViewerModal";
import {
  ConfirmationSnackbar,
  ErrorSnackbar,
} from "../../../components/Common/CustomSnackbar";
import { getAllPhotos } from "../../../redux/dispatchers/gallery.dispatcher";
import axiosInstance from "../../../utils/config/config";

const AdminPhotoGallery = () => {
  const dispatch = useDispatch();
  const { allPhotos } = useSelector((state) => state.gallery);

  const [addPhotoModal, setAddPhotoModal] = useState(false);
  const [selectedPhoto, setSelectedPhoto] = useState(null);
  const [success, setSuccess] = useState(false);
  const [errorState, setErrorState] = useState({ error: false, errorMsg: "" });

  useEffect(() => {
    dispatch(getAllPhotos());
  }, [dispatch]);

  const handleDelete = async () => {
    try {
      await axiosInstance.delete(`/gallery/deletePhoto/${selectedPhoto.id}`);
      setSelectedPhoto(null);
      dispatch(getAllPhotos());
    } catch (error) {
      setErrorState({
        error: true,
        errorMsg: error?.response?.data?.message || "Failed to delete photo",
      });
    }
  };

  return (
    <AdminLayout
      heading="Gallery"
      actionButton={
        <CustomBtn
          text="Add Photo"
          icon
          width="160px"
          height="45px"
          fontSize="16px"
          onClick={() => setAddPhotoModal(true)}
        />
      }
    >
      <ErrorSnackbar
        error={errorState.error}
        handleCloseError={() => setErrorState({ error: false, errorMsg: "" })}
        errorMsg={errorState.errorMsg}
      />
      <ConfirmationSnackbar
        snackbarState={success}
        handleSnackbarClose={() => setSuccess(false)}
        text="Photo Added Successfully"
      />

      <Grid container spacing={2}>
        {allPhotos?.map((photo) => (
          <Grid item size={{ xs: 6, sm: 4, md: 3 }} key={photo.id}>
            <Box
              component="img"
              src={photo.image_url}
              alt="gallery"
              onClick={() => setSelectedPhoto(photo)}
              sx={{
                width: "100%",
                height: "160px",
                objectFit: "cover",
                borderRadius: "12px",
                border: theme.lightBorder,
                display: "block",
                cursor: "pointer",
              }}
            />
          </Grid>
        ))}
      </Grid>

      <AddPhotoModal
        open={addPhotoModal}
        onClose={() => setAddPhotoModal(false)}
        onCreated={() => {
          setSuccess(true);
          dispatch(getAllPhotos());
        }}
        setErrorState={setErrorState}
      />

      <MediaViewerModal
        open={Boolean(selectedPhoto)}
        onClose={() => setSelectedPhoto(null)}
        src={selectedPhoto?.image_url}
        title="Photo"
        rotatable
        onDelete={handleDelete}
      />
    </AdminLayout>
  );
};

export default AdminPhotoGallery;
